import { DataUtilities } from "../../Common/DataUtilities";
import { StateManager } from "../../Common/StateManager";
import { IConfigStorage } from "../../Common/IConfigStorage";

export enum FlowStepOutputInstructionType {
    END_FLOW = "End flow",
    THROW_EXCEPTION = "End in error",
    CONTINUE = "Continue",
    BRANCH = "Link to new sequence",
}

export class FlowStepOutputInstructions implements IConfigStorage {
    static ERROR_MESSAGE = "errorMessage";
    static STRATEGY = "strategy";
    connectedSequenceId?: string;
    pathName: string;
    stepId: string;
    candidateStackX: number = -1;
    candidateStackY: number = -1;

    constructor(pathName: string, stepId: string) {
        this.pathName = pathName;
        this.stepId = stepId;
        this.connectedSequenceId = DataUtilities.generateUniqueId();
    }

    private _strategy: FlowStepOutputInstructionType = FlowStepOutputInstructionType.BRANCH;

    get strategy(): FlowStepOutputInstructionType {
        return this._strategy;
    }

    set strategy(value: FlowStepOutputInstructionType) {
        this._strategy = value;

        if (value !== FlowStepOutputInstructionType.BRANCH) this.connectedSequenceId = DataUtilities.generateUniqueId();

        // trigger refresh
        StateManager.propertyChanged(this, FlowStepOutputInstructions.STRATEGY);
    }

    private _errorMessage: string = "step error";

    get errorMessage(): string {
        return this._errorMessage;
    }

    set errorMessage(value: string) {
        this._errorMessage = value;
        StateManager.propertyChanged(this, FlowStepOutputInstructions.ERROR_MESSAGE);
    }

    getElementId(): string {
        return this.stepId + "-" + this.pathName.replace(/\s/g, "");
    }

    getStorageData(): object {
        return DataUtilities.addStorageData(
            this,
            undefined,
            "connectedSequenceId",
            "pathName",
            "stepId",
            "candidateStackX",
            "candidateStackY"
        );
    }

    setStorageData(data: object): void {
        return DataUtilities.setStorageData(
            this,
            data,
            "connectedSequenceId",
            "pathName",
            "stepId",
            "candidateStackX",
            "candidateStackY"
        );
    }
}
